import { useLanguage } from "../App";
import { motion } from "framer-motion";
import { X, FileText, Shield, Scale, Cookie } from "lucide-react";

const icons = {
  terms: FileText,
  privacy: Shield,
  legal: Scale,
  cookies: Cookie,
};

export const LegalModals = ({ type, onClose }) => {
  const { t } = useLanguage();

  const getContent = () => {
    switch (type) {
      case "terms":
        return t.legal.terms;
      case "privacy":
        return t.legal.privacy;
      case "legal":
        return t.legal.legalNotice;
      case "cookies":
        return t.legal.cookiePolicy;
      default:
        return { title: "", content: "" };
    }
  };

  const content = getContent();
  const Icon = icons[type] || FileText;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="modal-overlay"
      onClick={onClose}
      data-testid={`legal-modal-${type}`}
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] overflow-hidden"
      >
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b bg-white">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-slate-100 rounded-xl">
              <Icon size={24} className="text-slate-600" />
            </div>
            <h2 className="font-playfair text-2xl font-bold text-slate-900">
              {content.title}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-100 rounded-lg transition-colors"
            data-testid="legal-close"
          >
            <X size={20} className="text-slate-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] bg-white">
          <p className="text-slate-600 leading-relaxed whitespace-pre-line">
            {content.content}
          </p>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default LegalModals;
